// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graphvideo-canvas
{
    position: absolute;
}



.buttons-div-graph
{
    position: absolute;
    
}`, "",{"version":3,"sources":["webpack://./src/applications/dialogs/addvideo/graphvideo/graphvideo.css"],"names":[],"mappings":"AAAA;;IAEI,kBAAkB;AACtB;;;;AAIA;;IAEI,kBAAkB;;AAEtB","sourcesContent":[".graphvideo-canvas\n{\n    position: absolute;\n}\n\n\n\n.buttons-div-graph\n{\n    position: absolute;\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
